module.exports = __webpack_public_path__ + "img/button_dreamerz.dc14e997.png";